import { MessageView } from "@/interfaces/Chat";
const isMeetUri = (value: string) =>
  /^https:\/\/meet\.google\.com\/[a-z]{3}-[a-z]{4}-[a-z]{3}$/.test(value);
export default function MeetMessageCard({ message }: { message: MessageView }) {
  const uri = message.meet?.meetingUri;
  return (
    <div className="chat-meet-card">
      <strong>Google Meet</strong>
      <span>Réunion vidéo</span>
      {uri && isMeetUri(uri) ? (
        <a
          className="btn btn-outline-primary"
          href={uri}
          target="_blank"
          rel="noopener noreferrer"
        >
          Rejoindre
        </a>
      ) : (
        <span>Lien indisponible</span>
      )}
    </div>
  );
}
